var map = {
	"./busd.svg": 95963,
	"./dai.e.svg": 15690,
	"./dyp.svg": 28648,
	"./idyp.svg": 90897,
	"./link.e.svg": 20802,
	"./png.svg": 22982,
	"./qi.svg": 73075,
	"./usdc.e.svg": 8797,
	"./usdcIcon.svg": 74969,
	"./usdt.e.svg": 20902,
	"./usdt.svg": 46069,
	"./wavax.svg": 89130,
	"./wbtc.e.svg": 42902,
	"./weth.e.svg": 47330,
	"./xava.svg": 66167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59209;